import actionTypes from '../actions/action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_USER_ACTIVITY_REPORTS_SUCCESS:
      return [...action.items];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/admin-reports/reducers/items.js